module.exports = __webpack_public_path__ + "img/Growth.04bd4c51.svg";